import {
  Badge,
  Box,
  Button,
  Chip,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import moment from "moment";

const ResponsiveActions = ({
  activity,
  setShowReportingDialog,
  downloading,
  downloadSpecialOutputReportingTemplate,
}) => {
  const theme = useTheme();
  // const isXs = useMediaQuery(theme.breakpoints.down("sm")); // xs < sm

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
        gap: 1,
        minWidth: { xs: 200, sm: "auto" },
        ml: 1,
      }}
    >
      {/* Meta (Deadline + Status) */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          justifyContent: { xs: "space-between", sm: "flex-end" },
          whiteSpace: "nowrap",
        }}
      >
        <Tooltip title="Planned completion date">
          <Typography
            variant="body2"
            sx={{ color: "info.main", fontWeight: 500 }}
          >
            Deadline: {moment(activity.endOn).format("ll")}
          </Typography>
        </Tooltip>

        <Chip
          size="small"
          variant="filled"
          color={
            activity.statusId === 4
              ? "success"
              : activity.statusId === 3
              ? "primary"
              : activity.statusId === 1
              ? "default"
              : "warning"
          }
          label={activity.statusName}
          icon={
            <span className="material-icons" style={{ fontSize: 16 }}>
              {activity.statusId === 4 && "check_circle"}
              {activity.statusId === 3 && "file_present"}
              {activity.statusId === 1 && "schedule"}
              {[2, 5].includes(activity.statusId) && "warning"}
            </span>
          }
          sx={{ ".MuiChip-icon": { color: "inherit !important" } }}
        />
      </Box>

      {/* Primary CTA */}
      <Badge
        color="error"
        variant="dot"
        overlap="circular"
        invisible={activity.statusId !== 3}
      >
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={() => setShowReportingDialog(true)}
          startIcon={
            <span className="material-icons" style={{ fontSize: 18 }}>
              file_present
            </span>
          }
          aria-label="Report now"
          sx={{
            width: { xs: "100%", sm: "auto" }, // full width on small screens
            px: { xs: 1, sm: 1.5 },
          }}
          disabled={downloading}
        >
          <Box sx={{ display: { xs: "none", sm: "inline" } }}>Report</Box>
        </Button>
      </Badge>

      {/* Secondary: Template (when applicable) */}
      {!!activity.isSpecial &&
        activity.itemTypeId === 2 &&
        ![3, 4].includes(activity.statusId) && (
          <Button
            size="small"
            variant="outlined"
            color="info"
            onClick={() => downloadSpecialOutputReportingTemplate(() => {})}
            startIcon={
              <span className="material-icons" style={{ fontSize: 18 }}>
                file_download
              </span>
            }
            aria-label="Download report template"
            sx={{
              width: { xs: "100%", sm: "auto" }, // full width on small screens
              px: { xs: 1, sm: 1.5 },
            }}
            disabled={downloading}
          >
            <Box sx={{ display: { xs: "none", sm: "inline" } }}>Template</Box>
          </Button>
        )}
    </Box>
  );
};

export default ResponsiveActions;
